import type { MotifComponent, MotifComponentProps } from '../../motif';
import { m } from '../../motif/m';

/** NOTE: Tiles always have white background with black text. */
export const defaultTileVars: MotifComponentProps<MotifComponent.TILE> = {
  '--tile-bg-color': m('--neutral-v0'),
  '--tile-fg-color': m('--neutral-v700'),
} as const;
